import { Link } from 'react-router-dom';

const ENTRIES = [
  {
    to: '/category/movie',
    icon: 'ri-movie-2-line',
    title: '电影',
    desc: '最新热门大片 · 经典高分佳作',
    image:
      'https://readdy.ai/api/search-image?query=Cinema%20hall%20with%20glowing%20film%20screen%20and%20rows%20of%20seats%2C%20deep%20blue%20ambient%20lighting%20with%20warm%20accent%20glow%2C%20cinematic%20atmospheric%20mood&width=800&height=500&seq=cat-movie&orientation=landscape',
    accent: 'from-primary-950/90 to-primary-800/60',
  },
  {
    to: '/category/tv',
    icon: 'ri-tv-2-line',
    title: '电视剧',
    desc: '热播剧集 · 经典剧集全集回顾',
    image:
      'https://readdy.ai/api/search-image?query=Cozy%20living%20room%20with%20large%20TV%20showing%20warm%20scene%20at%20evening%2C%20soft%20orange%20and%20blue%20ambient%20lighting%2C%20comfortable%20home%20viewing%20atmosphere&width=800&height=500&seq=cat-tv&orientation=landscape',
    accent: 'from-accent-900/90 to-accent-700/60',
  },
];

export default function CategoryEntry() {
  return (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
      {ENTRIES.map((entry) => (
        <Link
          key={entry.to}
          to={entry.to}
          className="group relative h-44 overflow-hidden rounded-lg md:h-52"
        >
          <img
            src={entry.image}
            alt={entry.title}
            title={`八戒影院${entry.title}频道`}
            className="h-full w-full object-top transition-transform duration-500 group-hover:scale-105"
          />
          <div className={`absolute inset-0 bg-gradient-to-r ${entry.accent}`} />
          <div className="absolute inset-0 flex flex-col justify-center gap-2 px-6">
            <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-accent-500 text-background-50">
              <i className={`${entry.icon} text-2xl`} />
            </span>
            <h3 className="text-2xl font-bold text-background-50 font-heading">{entry.title}</h3>
            <p className="text-sm text-background-200">{entry.desc}</p>
          </div>
        </Link>
      ))}
    </div>
  );
}